import GroupLabel from "@molecules/GroupLabel/GroupLabel"

import styles from "./NavigationSection.module.scss"
import { NavigationSectionProps } from "./NavigationSection.types"

export default function NavigationSection(props: NavigationSectionProps) {
    const { title, children } = props

    return (
        <nav className={styles.base}>
            <GroupLabel
                variant="tertiary"
                label={title}
                isCollapsible={false}
                showPrefixSlot={false}
                showMiddleSlot={false}
            />
            {children}
        </nav>
    )
}
